import { Platform } from 'react-native';
import { loadAsync, useFonts } from 'expo-font';
import Ionicons from '@expo/vector-icons/Ionicons';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { preloadIconFonts } from './iconFontPreload';

/**
 * Загрузка шрифтов приложения. Живёт отдельно от agapellaFonts.ts намеренно:
 * `expo-font` поставляется как ESM и ломает jest, если попадает в цепочку
 * импортов компонентов. Хук нужен только композиционному корню (App.tsx),
 * а стилям достаточно чистых uiFont/displayFont.
 */
const isWeb = Platform.OS === 'web';

// CORE-1904 — на вебе шрифты иконок запрашиваем до первого рендера и с catch:
// иначе каждая иконка ждёт их сама, и таймаут FontFaceObserver (6 с) падает
// необработанным отказом. Новое семейство иконок — добавить сюда.
if (isWeb) {
  preloadIconFonts(loadAsync, { ...Ionicons.font, ...MaterialCommunityIcons.font });
}

/** На вебе шрифты приходят CSS-переменными, нативные файлы туда не грузятся. */
const FONT_ASSETS: Record<string, any> = isWeb ? {} : {
  'NunitoSans-Regular': require('../../assets/fonts/NunitoSans_400Regular.ttf'),
  'NunitoSans-Medium': require('../../assets/fonts/NunitoSans_500Medium.ttf'),
  // 600/700 — заголовки и кнопки утверждённой системы (Nunito Sans 400/600/700).
  // Android не синтезирует начертания, поэтому каждый вес — отдельный файл.
  'NunitoSans-SemiBold': require('../../assets/fonts/NunitoSans_600SemiBold.ttf'),
  'NunitoSans-Bold': require('../../assets/fonts/NunitoSans_700Bold.ttf'),
  'Lora-Medium': require('../../assets/fonts/Lora_500Medium.ttf'),
};

/** Рендер намеренно НЕ блокируется: до готовности текст рисуется системным. */
export function useAgapellaFonts(): boolean {
  const [loaded] = useFonts(FONT_ASSETS);
  return loaded;
}
